import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

const KnivesList = () => {
  const [knives, setKnives] = useState([]);

  useEffect(() => {
    axios.get("http://localhost:3000/api/knives")
      .then((response) => setKnives(response.data))
      .catch((error) => console.error("Error fetching knives:", error));
  }, []);

  return (
    <div className="container mx-auto py-10">
      <h1 className="text-3xl font-momo text-left mb-6">Hnífar</h1>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {knives.map((knife) => (
          <Link to={`/product/${knife.id}`} key={knife.id} className="border p-4 rounded-lg shadow-lg block">
            <img src={knife.image} alt={knife.name} className="w-full h-40 object-cover" />
            <h2 className="text-xl font-semibold mt-2">{knife.name}</h2>
            <p className="text-gray-600">${knife.price}</p>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default KnivesList;